export default {
  data() {
    return {
      isCtrlPressed: false
    }
  },
  methods: {
    sanitise(string) {
      string = string.split(" ").join("").trim().replace(/\D/g, '');
      return string
    },
    checkKey(e) {
      if (e.keyCode === 86) {
        this.isCtrlPressed = false
      }
    },
    preventKeys(e) {
      if (/[0-9]/.test(e.key)) {
        return
      }
      switch (e.key) {
        case 'Control':
          this.isCtrlPressed = true
          return
        case 'Backspace':
        case 'Delete':
        case 'ArrowLeft':
        case 'ArrowRight':
        case 'Tab':
          return
      }
      if (e.keyCode === 86 && this.isCtrlPressed) {
        return
      }
      e.preventDefault()
    }
  }
}